import { Hospital } from "@/shared/types/hospitals";
import { hospital as api } from "../../api/hospital.api";

const state = {
	hospital: null,
	isFetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};

const getters = {
	get: (state) => state.hospital as Hospital
};

const actions = {
	async fetch({ commit, dispatch }, id) {
		commit("LOAD_START");
		const hospital = await api.get(id);

		dispatch("healthServiceModule/set", hospital.healthservice, {
			root: true
		});

		commit("SET_HOSPITAL", hospital);

		commit("LOAD_FINISH");
	},
	create() {},
	update() {},
	remove() {}
};

const mutations = {
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	SET_HOSPITAL(state: any, hospital: Hospital) {
		state.hospital = hospital;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
